import type { ExpertSegmentationLineage } from '@/client/services/api/graphql/gql/graphql';

export const formatSegmentationLineageName = (segmentationLineage: ExpertSegmentationLineage) => {
  if (segmentationLineage.parent?.parent) {
    return `${segmentationLineage.parent.parent.segmentationName} -> ${segmentationLineage.parent.segmentationName} -> ${segmentationLineage.segmentationName}`;
  }

  if (segmentationLineage.parent) {
    return `${segmentationLineage.parent.segmentationName} -> ${segmentationLineage.segmentationName}`;
  }

  return segmentationLineage.segmentationName;
};
